import { ReactNode, useMemo, useEffect } from 'react';

import { createCtx } from '@pletly/ui';
import { useUser } from '%hooks';
import { useProtegesList } from './useProtegesList';
import { useProtegesUpdatedSubscription } from './useProtegesUpdatedSubscription';

type ContextType = ReturnType<typeof useProtegesList>;

const [useConnections, ConnectionsDataProvider] = createCtx<ContextType>();

const ConnectionsProvider = ({ children }: { children?: ReactNode }) => {
	const user = useUser();
	const {
		proteges,
		superPalOf,
		createdCareReceiverAccounts,
		temporaryProteges,
		careRecipients,
		loading,
		error,
		refetch,
	} = useProtegesList();
	useProtegesUpdatedSubscription();

	useEffect(() => {
		if (!user?.id) {
			return;
		}
		void refetch();
	}, [user?.id, refetch]);

	const value = useMemo(
		() => ({
			proteges,
			superPalOf,
			createdCareReceiverAccounts,
			temporaryProteges,
			careRecipients,
			loading,
			error,
			refetch,
		}),
		[
			proteges,
			superPalOf,
			createdCareReceiverAccounts,
			temporaryProteges,
			careRecipients,
			loading,
			error,
			refetch,
		],
	);

	return <ConnectionsDataProvider value={value}>{children}</ConnectionsDataProvider>;
};

export { useConnections, ConnectionsProvider };
